import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SeoTextLoadingContext } from '../SeoTextLoadingProvider/SeoTextLoadingProvider';

export const useUpdateSeoTextLoading = () => {
  const location = useLocation();
  const { isLoaded, setIsLoaded } = useContext(SeoTextLoadingContext);

  useEffect(() => {
    if (isLoaded) {
      setIsLoaded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return setIsLoaded;
};
